import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { motion, AnimatePresence } from 'framer-motion'
import { DashedBorderSvg } from '@components/layout/dashedBorderSvg'
import * as css from './styles'
import { importStatus } from './types'
import { UploadMessage } from './uploadMessage'
import { UploaderAnimation } from './uploadSvg'
import { ValidColumnOrder } from './validColumnOrder'

const DefaultUpload = () => (
  <UploadMessage keyName="upload-default">
    <UploadMessage.Title>
      <Trans>
        Drag & drop
        <br />
        or Choose File to upload (CSV filetype)
      </Trans>
    </UploadMessage.Title>
    <UploadMessage.Description>
      {t`Uploading a new file will completely replace your current list, including all headers and data. Ensure the uploaded file has the desired structure.`}
    </UploadMessage.Description>
    <ValidColumnOrder />
  </UploadMessage>
)

const CompletedUpload = () => (
  <UploadMessage keyName="upload-complete">
    <UploadMessage.Title>{t`List has been imported successfully!`}</UploadMessage.Title>
    <UploadMessage.Description>
      {t`Large lists may take a few minutes to process...`}
    </UploadMessage.Description>
    <UploadMessage.Status status={importStatus.IN_PROGRESS} />
  </UploadMessage>
)

const FailedToUpload = ({ error }) => (
  <UploadMessage keyName="upload-failed">
    <UploadMessage.Title>{t`Uh oh.`}</UploadMessage.Title>
    <UploadMessage.Description>{error.message}</UploadMessage.Description>
    <UploadMessage.Status status={importStatus.FAILED} />
  </UploadMessage>
)

export const UploadStatus = ({ status, error, progress = 0 }) => {
  const isUploadingStatus = status === importStatus.UPLOADING
  const isInProgressStatus = status === importStatus.IN_PROGRESS
  const isFailedStatus = status === importStatus.FAILED
  const isDefaultStatus = status === importStatus.DEFAULT
  const uploadInProgress = progress > 0 && progress < 1
  const uploadComplete = progress === 1

  return (
    <>
      <css.DropFile>
        <UploaderAnimation
          status={status}
          uploadInProgress={uploadInProgress}
          uploadComplete={uploadComplete}
        >
          <UploaderAnimation.ProgressCircle status={status} progress={progress} />
        </UploaderAnimation>
        {isInProgressStatus ? <CompletedUpload /> : null}
        {isFailedStatus ? <FailedToUpload error={error} /> : null}
        {isDefaultStatus || isUploadingStatus ? <DefaultUpload /> : null}
      </css.DropFile>
      <AnimatePresence>
        {isDefaultStatus ? (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <DashedBorderSvg />
          </motion.div>
        ) : null}
      </AnimatePresence>
    </>
  )
}
